import { configureStore } from '@reduxjs/toolkit';
import { setupListeners } from '@reduxjs/toolkit/query';
import { authApi } from './authApi';
import { topicApi } from './topicApi'; // Import topicApi
import { adminApi } from './adminApi'; // Import adminApi
import { sprintApi } from './sprintApi'; // Import sprintApi
import authReducer from './authSlice';

export const store = configureStore({
  reducer: {
    [authApi.reducerPath]: authApi.reducer,
    [topicApi.reducerPath]: topicApi.reducer, // Add topicApi reducer
    [adminApi.reducerPath]: adminApi.reducer, // Add adminApi reducer
    [sprintApi.reducerPath]: sprintApi.reducer, // Add sprintApi reducer
    auth: authReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(authApi.middleware, topicApi.middleware, adminApi.middleware, sprintApi.middleware), // Add topicApi, adminApi, and sprintApi middleware
});

setupListeners(store.dispatch);

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
